import React from "react";
import "./CSS/Contact.css";

const Contact = () => {
  return (
    <div className="contact-container">
      <h1>Get In Touch With Us</h1>
      <p className="subtitle">
        For More Information About Our Product & Services, Please Feel Free To Drop Us
        An Email. Our Staff Always Be There To Help You Out. Do Not Hesitate!
      </p>

      <div className="contact-content">
        {/* LEFT SIDE */}
        <div className="contact-left">
          <label>Your name</label>
          <input type="text" placeholder="Abc" />

          <label>Email address</label>
          <input type="email" placeholder="Abc@def.com" />

          <label>Message</label>
          <textarea placeholder="Hi! I'd like to ask about"></textarea>

          <button>Submit</button>

          <div className="contact-info">
            <h3>Address</h3>
            <p>
              Aggarwal Pride, Flat No. D-08, Near Surya Hospital,
              1308, Kasba Peth, Pune (Municipal Corporation),
              Pune City, Pune, 411011
            </p>

            <h3>Phone</h3>
            <p>Mobile: +91 83 08 01 71 71</p>

            <h3>Working Time</h3>
            <p>Monday–Sunday: <br /> 9:00 am – 06:00 pm</p>
          </div>
        </div>

        {/* RIGHT SIDE (MAP) */}
        <div className="contact-right">
          <h3>  Locate Us</h3>
          <iframe
            title="map"
            src="https://www.google.com/maps?q=Pune&output=embed"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;